import type { TFunction } from 'i18next';
import { TRoomsParams } from '../../../common/types/floor-params.type';
import { RoomType } from '../types';

const getKitchenTitle = (translate?: TFunction) => (translate ? translate('roomTypes.kitchen') : 'Кухня');
const getBathroomTitle = (translate?: TFunction) => (translate ? translate('roomTypes.bathroom') : 'Ванная');
const getLivingRoomTitle = (translate?: TFunction) =>
  translate ? translate('roomTypes.livingRoom') : 'Гостиная';
const getBedroomTitle = (translate?: TFunction) => (translate ? translate('roomTypes.bedroom') : 'Спальня');
const getHallwayTitle = (translate?: TFunction) => (translate ? translate('roomTypes.hallway') : 'Прихожая');
const getNurseryTitle = (translate?: TFunction) => (translate ? translate('roomTypes.nursery') : 'Детская');
const getOfficeSpaceTitle = (translate?: TFunction) =>
  translate ? translate('roomTypes.officeSpace') : 'Офис';
const getRoomTitle = (translate?: TFunction) => (translate ? translate('roomTypes.default') : 'Комната');

export const getRoomTypeTitle = ({ room, translate }: { room: TRoomsParams; translate?: TFunction }) => {
  switch (room.roomType) {
    case RoomType.KITCHEN:
      return getKitchenTitle(translate);
    case RoomType.BATHROOM:
      return getBathroomTitle(translate);
    case RoomType.LIVING_ROOM:
      return getLivingRoomTitle(translate);
    case RoomType.BEDROOM:
      return getBedroomTitle(translate);
    case RoomType.HALLWAY:
      return getHallwayTitle(translate);
    case RoomType.NURSERY:
      return getNurseryTitle(translate);
    case RoomType.OFFICE_SPACE:
      return getOfficeSpaceTitle(translate);
    default:
      return getRoomTitle(translate);
  }
};
